export const dispatchWithNextState = (nextState, dispatch) => {
  dispatch(nextState);

  return nextState;
};
